import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Table, Input, Button, Space } from "antd";
import { useParams } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";

function Classroom() {
  const { id } = useParams();
  const [className, setClassName] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowKeysClass, setSelectedRowKeysClass] = useState([]);
  const [students, setStudents] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .get("http://78.186.196.90:8091/ClassRoom/Get?Id=" + id)
        .then((response) => {
          setStudents(response.data);
          setClassName(response.data.title);
          const tempArr = [];
          console.log("Students", response.data.students);
          response.data.students.map((student) => {
            return tempArr.push(student.userId);
          });
          // setSelectedRowKeysClass(tempArr);
        })
        .catch((e) => {
          console.log(e);
        });
    };
    if (id != 0) fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "http://78.186.196.90:8091/User/GetAllUser?userId=" +
          JSON.parse(localStorage.getItem("user")).id +
          "&role=teacher"
      );
      setAllStudents(response.data);
    };
    fetchData();
  }, []);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const onSelectChangeClass = (newSelectedRowKeysClass) => {
    setSelectedRowKeysClass(newSelectedRowKeysClass);
    console.log("selectedRowKeysClasss changed: ", selectedRowKeysClass);
  };

  const rowSelectionClass = {
    selectedRowKeysClass,
    onChange: onSelectChangeClass,
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const handleChange = (e) => {
    setClassName(e.currentTarget.value);
  };

  const handleSave = () => {
    const arr = [];
    const newStudents = selectedRowKeys.concat(selectedRowKeysClass);
    newStudents.map((item) => {
      const student = allStudents.users.filter((x) => x.id === item);
      arr.push({
        studentId: item,
        studentName:
          student.map((x) => x.title)[0] != null
            ? student.map((x) => x.title)[0]
            : "",
      });
    });
    const user = JSON.parse(localStorage.getItem("user"));

    axios
      .post("http://78.186.196.90:8091/ClassRoom/Add", {
        id: id,
        title: className,
        username: user.username,
        teacherId: user.id,
        students: arr,
      })
      .then(function (response) {
        window.location.href = "http://78.186.196.90:8181/ClassRooms";
      })
      .catch(function (error) {});
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    // render: (text) =>
    //   searchedColumn === dataIndex ? (
    //     <Highlighter
    //       highlightStyle={{
    //         backgroundColor: "#ffc069",
    //         padding: 0,
    //       }}
    //       searchWords={[searchText]}
    //       autoEscape
    //       textToHighlight={text ? text.toString() : ""}
    //     />
    //   ) : (
    //     text
    //   ),
  });

  const columns = [
    {
      title: "Student ID",
      dataIndex: "userId",
      key: "userId",
      width: "20%",
      ...getColumnSearchProps("userId"),
    },
    {
      title: "Username",
      dataIndex: "userName",
      key: "userName",
      width: "30%",
      ...getColumnSearchProps("username"),
    },

    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      ...getColumnSearchProps("createdDate"),
      sorter: (a, b) => a.createdDate - b.createdDate,
      sortDirections: ["descend", "ascend"],
    },
  ];

  const columnsAllStudents = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "20%",
      ...getColumnSearchProps("id"),
    },
    {
      title: "Students Name",
      dataIndex: "title",
      key: "title",
      width: "30%",
      ...getColumnSearchProps("title"),
    },

    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      ...getColumnSearchProps("country"),
      sorter: (a, b) => a.country - b.country,
      sortDirections: ["descend", "ascend"],
    },
  ];

  return (
    <>
      <main>
        <header>
          <div className="flex-row">
            {id != 0 && <h1>{students.title}</h1>}
            {id == 0 && (
              <div className="entry">
                <label>Classroom Name</label>
                <Input
                  placeholder="Enter classroom name"
                  onChange={handleChange}
                />
              </div>
            )}

            <Button type="primary" onClick={handleSave}>
              Save
            </Button>
          </div>
        </header>

        <div className="flex-row flex-start">
          <section className="half">
            <header>
              <h2>All Students</h2>
            </header>
            <Table
              rowSelection={rowSelection}
              columns={columnsAllStudents}
              dataSource={allStudents.users}
              rowKey="id"
            />
          </section>
          <section className="half">
            <header>
              <h2>Students in Class</h2>
            </header>
            <Table
              rowSelection={rowSelectionClass}
              columns={columns}
              dataSource={students.students}
              rowKey="userId"
            />
          </section>
        </div>
      </main>
    </>
  );
}

export default Classroom;
